import React, { useMemo } from 'react';
import ProductSearchProvider, {
  productEquals,
  useProductSearchSelector,
} from '../ProductSearchProvider';
import ProductSlider from '../ProductSlider';
import {
  selectIsProductSearching,
  selectProducts,
} from '~redux/search/product';
import { ProductReadModel } from '~types/api';

const Slider: React.FC<{
  listId: string;
  category?: string;
  subcategory?: string;
  title?: string;
  listPath?: string;
}> = React.memo(({ listId, category, subcategory, title, listPath }) => {
  const products = useProductSearchSelector(
    selectProducts,
    listId,
    productEquals
  );
  const isLoading = useProductSearchSelector(selectIsProductSearching, listId);
  return (
    <ProductSlider
      products={products as ProductReadModel[]}
      title={title ?? category}
      title2={title ? undefined : subcategory}
      listPath={listPath}
      isLoading={isLoading}
    />
  );
});

const CategoryProducts: React.FC<{
  category?: string;
  subcategory?: string;
  brandTag?: string;
  title?: string;
  listPath?: string;
  isLoading?: boolean;
}> = ({ category, subcategory, brandTag, title, listPath, isLoading }) => {
  const listId = useMemo(
    () =>
      brandTag
        ? brandTag
        : `products > carousel > ${category}${
            subcategory ? ` > ${subcategory}` : ''
          }`,
    [brandTag, category, subcategory]
  );
  const filters = useMemo(
    () =>
      (brandTag ? { brand_tags: [brandTag] } : {}) as Record<string, string[]>,
    [brandTag]
  );
  const filterValues = useMemo(
    () =>
      (brandTag ? { brand_tags: [`brand_tags:${brandTag}`] } : {}) as Record<
        string,
        string[]
      >,
    [brandTag]
  );

  if (isLoading) {
    return <ProductSlider isLoading />;
  }
  // if (!category) {
  //   return null;
  // }

  return (
    <ProductSearchProvider
      listId={listId}
      sort={'recommended'}
      category={category}
      subCategory={subcategory}
      itemsPerPage={30}
      groupByBrand
      filters={filters}
      filterValues={filterValues}
    >
      <Slider
        listId={listId}
        category={category}
        subcategory={subcategory}
        title={title}
        listPath={listPath}
      />
    </ProductSearchProvider>
  );
};

export default CategoryProducts;
